module.exports = __webpack_public_path__ + "static/img/get_cocktail.b8550f46.png";